const navigation = [
    {name: 'Local', href: '/#local-support'},
    { name: 'IT Services', href: '/#services-offered' },
    { name: 'Pricing', href: '/#pricing' },
    { name: 'FAQ', href: '/#faq' },
    { name: 'Contact', href: '/#contact' },
    { name: 'Service Area', href: '/#service-area' }
];

export { navigation };